/* @/constants/regex.constants.ts */

export const alphaNumericOnlyRegex = new RegExp(
  /^[a-zA-Z0-9]+$/ // Only allow alphanumeric characters
);

export const usernameRegex = /^[a-zA-Z0-9]{3,12}(#[a-zA-Z0-9]{1,5})?$/; // 3-12 alphanumeric characters, optionally followed by a 1-5 character tag separated by a hash (#)

export const passwordRegex = new RegExp(
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/
);

export const passwordSymbolRegex = new RegExp(
  /[!#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/
);

export const invalidCharacterRegex = new RegExp(
  /[^A-Za-z\d!\"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/
);

export const amountRegex = new RegExp(
  /^[0-9]+(\.[0-9]*)?$/ // Only allow numbers, optionally followed by a decimal point and more numbers
);

export const emailRegex = new RegExp(
  /^(?![.-])[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/
);

export const ethWalletRegex = new RegExp(
  /^(0x)?[0-9a-fA-F]{40}$/ // Ethereum wallet address
);

export const phishingRegex =
  /^(?=.*[A-Za-z0-9!@#$%^&*])[A-Za-z0-9!@#$%^&*\s]*$/;

export const regex2FA = new RegExp(/^[a-zA-Z0-9]{6}$/); // 6-digit 2FA code
